import { ajaxSend } from '../../../../api/api';

const basePath = '/v1/organizations';

export function getOrganization(organizationID: string) {
  return ajaxSend({
    method: 'GET',
    path: `${basePath}/${organizationID}`,
  });
}

export function getOrganizationFeatureFlags(organizationID: string) {
  return ajaxSend({
    path: `${basePath}/${organizationID}/temporary/featureflags`,
  });
}

export function editOrganization(id: string, payload) {
  return ajaxSend({
    method: 'PATCH',
    data: payload,
    path: `${basePath}/${id}`,
  });
}

// Avatar
export function getPresignedAvatarUrl(file) {
  return ajaxSend({
    path: '/v1/uploads/presigned_url/organization_avatar',
    method: 'POST',
    data: {
      pretty_name: file.name,
      content_type: file.type,
    },
  });
}

export function uploadAvatar(presigned, file) {
  return ajaxSend({
    method: 'PUT',
    headers: {
      authorization: null,
      contentType: file.type,
    },
    data: file,
    path: presigned.upload_url,
  });
}
